(function () {
  'use strict';

  var CAROUSEL_SELECTOR = '.js_carousel, .nt_slider, [data-flickity], [data-flickityjs]';
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';
  var MARKER_ATTR = 'data-a11y-hidden-tabindex';

  function syncSlide(slide) {
    if (!slide || slide.nodeType !== 1) return;

    var hidden = slide.getAttribute('aria-hidden') === 'true';
    var focusable = slide.querySelectorAll(FOCUSABLE_SELECTOR);

    for (var i = 0; i < focusable.length; i++) {
      var el = focusable[i];

      if (hidden) {
        if (!el.hasAttribute(MARKER_ATTR)) {
          el.setAttribute(MARKER_ATTR, '1');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute(MARKER_ATTR)) {
        el.removeAttribute(MARKER_ATTR);
        el.removeAttribute('tabindex');
      }
    }
  }

  function syncAllSlides(root) {
    var carousels = root.querySelectorAll(CAROUSEL_SELECTOR);
    for (var i = 0; i < carousels.length; i++) {
      var slides = carousels[i].querySelectorAll('[aria-hidden]');
      for (var j = 0; j < slides.length; j++) {
        syncSlide(slides[j]);
      }
    }
  }

  function init() {
    syncAllSlides(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        syncSlide(mutations[i].target);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
